import { Box, Stack, Typography, useTheme } from "@mui/material";
import { FoodsIcon, FoodsTooltip } from "@foodpilot/foods";
import { buildIngredientsDataTooltip, IngredientTooltipProps } from "./buildIngredientsDataTooltip";

export const IngredientTooltip = (props: IngredientTooltipProps) => {
    const theme = useTheme();

    const tooltipContent = buildIngredientsDataTooltip(props);
    return (
        <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="body">{tooltipContent.message}</Typography>
            <FoodsTooltip
                sx={{
                    "& .MuiTooltip-tooltip": {
                        maxHeight: "unset",
                        height: "unset",
                    },
                }}
                arrow
                placement="top"
                title={
                    <Box padding="8px" textAlign="left">
                        <Typography variant="h4" sx={{ marginBottom: theme.spacing(2) }}>
                            {tooltipContent.tooltipTitle}
                        </Typography>
                        <Typography variant="body-bold" color={theme.palette.text.secondary}>
                            {tooltipContent.tooltipBody}
                        </Typography>
                    </Box>
                }
            >
                <Box display="flex">
                    <FoodsIcon icon="information" size={2} />
                </Box>
            </FoodsTooltip>
        </Stack>
    );
};
